export enum OrderStatus {
  Refund = 'REFUND',
  Void = 'VOID',
  Open = 'OPEN',
  Closed = 'CLOSED',
}

export enum OrderType {
  DineIn = 'DINE_IN',
  TakeAway = 'TAKE_AWAY',
  Indent = 'INDENT',
}
